import { render } from "./FooterLinkSection.vue?vue&type=template&id=36dc0547"
import script from "./FooterLinkSection.vue?vue&type=script&lang=js"
export * from "./FooterLinkSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__